// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* http://meyerweb.com/eric/tools/css/reset/ 
   v2.0 | 20110126
   License: none (public domain)
*/

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  /* biome-ignore lint/suspicious/noShorthandPropertyOverrides: <from http://meyerweb.com/eric/tools/css/reset/> */
  font: inherit;
  font-family: sans-serif;
  vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}
body {
  line-height: 1;
}
ol,
ul {
  list-style: none;
}
blockquote,
q {
  quotes: none;
}
blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  /* biome-ignore lint/suspicious/noDuplicateProperties: <from http://meyerweb.com/eric/tools/css/reset/> */
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
button {
  border: none;
}

/* Body definitions */

html,
div#root,
body {
  width: 100dvw;
  height: 100dvh;
}

div#root,
body {
  background-color: var(--background);
  color: var(--text);
  font-family: sans-serif;
  text-align: center;
}

/* Colors definitions */

:root {
  --background: #f1f1f1;
  --text: #1e1e1e;
  --link-text: #044fd0;
  --link-hover: #1e1e1e;
  --divider: #ccc;
  --nav-bg: #f1f1f1;
  --nav-text: #1e1e1e;
  --nav-divider: #ccc;

  /* Table-related light theme */
  --table-border-color: #ccc;
  --table-box-shadow-color: rgba(0, 0, 0, 0.05);
  --table-thead-background-color: #e6e6e6;
  --table-tbody-background-color: #ffffff;
  --table-split-line-color: #ddd;
  --table-th-text-color: #1e1e1e;
  --table-tbody-background-color-hover: #f9f9f9;

  /* Form-related light theme */
  --form-border-color: #ccc;
  --form-input-border-color: #bbb;
  --form-input-background-color: #ffffff;
  --form-input-text-color: #1e1e1e;
  --form-button-text-color: #ffffff;
  --form-button-background-color: #044fd0;
  --form-button-background-color-hover: #033bb0;

  @media screen and (prefers-color-scheme: dark) {
    --background: #1e1e1e;
    --text: #f1f1f1;
    --link-text: #94bbff;
    --link-hover: #f1f1f1;
    --divider: #333;
    --nav-bg: #1e1e1e;
    --nav-text: #f1f1f1;
    --nav-divider: #333;

    /* Table-related dark theme */
    --table-border-color: #333;
    --table-box-shadow-color: rgba(255, 255, 255, 0.05);
    --table-thead-background-color: #2a2a2a;
    --table-tbody-background-color: #1e1e1e;
    --table-split-line-color: #444;
    --table-th-text-color: #f1f1f1;
    --table-tbody-background-color-hover: #2c2c2c;

    /* Form-related dark theme */
    --form-border-color: #444;
    --form-input-border-color: #555;
    --form-input-background-color: #2c2c2c;
    --form-input-text-color: #f1f1f1;
    --form-button-text-color: #1e1e1e;
    --form-button-background-color: #94bbff;
    --form-button-background-color-hover: #b4d0ff;
  }
}

/* Main Styles CSS */

:root {
  --border-size: 1px;
  --nav-border-size: 4px;
}

div#root {
  display: grid;
  align-content: space-between;
  grid-template-rows: auto 1fr auto;
}

.header {
  display: grid;
  padding: 0 1rem;
  background-color: var(--nav-bg);
  color: var(--nav-text);
  border-bottom: var(--border-size) solid var(--nav-divider);
}

.nav {
  display: grid;
  grid-auto-flow: column;
  height: 100%;
}

.nav__link--selected {
  border-bottom: var(--nav-border-size) solid var(--nav-divider);
}

.nav__link {
  -webkit-tap-highlight-color: transparent;
  transition: color 0.5s;
  color: var(--nav-text);
  text-decoration: none;
  padding: 1rem 0;
}

.nav__link:hover {
  color: var(--link-text);
}

.footer {
  display: grid;
  grid-auto-flow: column;
  justify-content: center;
  align-items: center;
  background-color: var(--nav-bg);
  padding: 1rem 0.5rem;
  color: var(--text);
  border-top: var(--border-size) solid var(--nav-divider);
}

.main {
  overflow: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.main::-webkit-scrollbar {
  display: none;
}

.section {
  display: grid;
  grid-auto-flow: row;
  justify-content: center;
  gap: 1rem;
  padding: 1rem;
}

.section__title,
.section__subtitle,
.section__description {
  max-width: 42rem;
}

.section__title {
  font-size: 2.5rem;
  @media screen and (max-width: 600px) {
    font-size: 2rem;
  }
}

.section__subtitle {
  margin-top: 1.5rem;
  font-size: 1.5rem;
  @media screen and (max-width: 600px) {
    font-size: 1.25rem;
  }
}

.section__description {
  font-weight: 300;
  line-height: 1.25rem;
}

.section__description--justify {
  text-align: justify;
  text-indent: 2rem;
}

.section__description--right {
  text-align: right;
}

.section__link {
  -webkit-tap-highlight-color: transparent;
  transition: color 0.5s;
  color: var(--link-text);
  text-decoration: none;
}

.section__link:hover {
  color: var(--link-text-hover);
  text-decoration: underline;
}

.section__link:checked {
  text-decoration: line-through;
}

.page__list {
  display: grid;
  grid-auto-flow: row;
  gap: 1rem;
  padding: 0 1rem 0 2rem;
}

.page__list__item {
  text-align: left;
}

.page__list__item--decimal-style {
  list-style: decimal;
}

.item__description {
  text-align: start;
}

.lang-switcher {
  appearance: none;
  background-color: var(--nav-bg);
  color: var(--nav-text);
  border: 1px solid var(--nav-divider);
  border-radius: 4px;
  padding: 0.25rem 0.5rem;
  font: inherit;
  cursor: pointer;
  align-self: center;
  margin-left: auto;
  transition:
    border-color 0.2s,
    color 0.2s;
}

.lang-switcher:hover {
  border-color: var(--link-text);
  color: var(--link-text);
}

.lang-switcher:focus-visible {
  outline: 2px solid var(--link-text);
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./../web2/src/styles.css"],"names":[],"mappings":"AAAA;;;CAGC;;AAED;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiFE,SAAS;EACT,UAAU;EACV,SAAS;EACT,eAAe;EACf,gHAAgH;EAChH,aAAa;EACb,uBAAuB;EACvB,wBAAwB;AAC1B;AACA,gDAAgD;AAChD;;;;;;;;;;;EAWE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,YAAY;AACd;AACA;;;;EAIE,WAAW;EACX,yGAAyG;EACzG,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;;AAEA,qBAAqB;;AAErB;;;EAGE,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,mCAAmC;EACnC,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,uBAAuB;;AAEvB;EACE,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;;EAEnB,8BAA8B;EAC9B,0BAA0B;EAC1B,6CAA6C;EAC7C,uCAAuC;EACvC,uCAAuC;EACvC,8BAA8B;EAC9B,8BAA8B;EAC9B,6CAA6C;;EAE7C,6BAA6B;EAC7B,yBAAyB;EACzB,+BAA+B;EAC/B,sCAAsC;EACtC,gCAAgC;EAChC,iCAAiC;EACjC,uCAAuC;EACvC,6CAA6C;;EAE7C;IACE,qBAAqB;IACrB,eAAe;IACf,oBAAoB;IACpB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;;IAEnB,6BAA6B;IAC7B,0BAA0B;IAC1B,mDAAmD;IACnD,uCAAuC;IACvC,uCAAuC;IACvC,8BAA8B;IAC9B,8BAA8B;IAC9B,6CAA6C;;IAE7C,4BAA4B;IAC5B,yBAAyB;IACzB,+BAA+B;IAC/B,sCAAsC;IACtC,gCAAgC;IAChC,iCAAiC;IACjC,uCAAuC;IACvC,6CAA6C;EAC/C;AACF;;AAEA,oBAAoB;;AAEpB;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,+BAA+B;EAC/B,sBAAsB;EACtB,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,oBAAoB;EACpB,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,gBAAgB;EAChB,wBAAwB,EAAE,gBAAgB;EAC1C,qBAAqB,EAAE,YAAY;AACrC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;AACf;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB;;cAEY;AACd;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB","sourcesContent":["/* http://meyerweb.com/eric/tools/css/reset/ \n   v2.0 | 20110126\n   License: none (public domain)\n*/\n\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  /* biome-ignore lint/suspicious/noShorthandPropertyOverrides: <from http://meyerweb.com/eric/tools/css/reset/> */\n  font: inherit;\n  font-family: sans-serif;\n  vertical-align: baseline;\n}\n/* HTML5 display-role reset for older browsers */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block;\n}\nbody {\n  line-height: 1;\n}\nol,\nul {\n  list-style: none;\n}\nblockquote,\nq {\n  quotes: none;\n}\nblockquote:before,\nblockquote:after,\nq:before,\nq:after {\n  content: \"\";\n  /* biome-ignore lint/suspicious/noDuplicateProperties: <from http://meyerweb.com/eric/tools/css/reset/> */\n  content: none;\n}\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\nbutton {\n  border: none;\n}\n\n/* Body definitions */\n\nhtml,\ndiv#root,\nbody {\n  width: 100dvw;\n  height: 100dvh;\n}\n\ndiv#root,\nbody {\n  background-color: var(--background);\n  color: var(--text);\n  font-family: sans-serif;\n  text-align: center;\n}\n\n/* Colors definitions */\n\n:root {\n  --background: #f1f1f1;\n  --text: #1e1e1e;\n  --link-text: #044fd0;\n  --link-hover: #1e1e1e;\n  --divider: #ccc;\n  --nav-bg: #f1f1f1;\n  --nav-text: #1e1e1e;\n  --nav-divider: #ccc;\n\n  /* Table-related light theme */\n  --table-border-color: #ccc;\n  --table-box-shadow-color: rgba(0, 0, 0, 0.05);\n  --table-thead-background-color: #e6e6e6;\n  --table-tbody-background-color: #ffffff;\n  --table-split-line-color: #ddd;\n  --table-th-text-color: #1e1e1e;\n  --table-tbody-background-color-hover: #f9f9f9;\n\n  /* Form-related light theme */\n  --form-border-color: #ccc;\n  --form-input-border-color: #bbb;\n  --form-input-background-color: #ffffff;\n  --form-input-text-color: #1e1e1e;\n  --form-button-text-color: #ffffff;\n  --form-button-background-color: #044fd0;\n  --form-button-background-color-hover: #033bb0;\n\n  @media screen and (prefers-color-scheme: dark) {\n    --background: #1e1e1e;\n    --text: #f1f1f1;\n    --link-text: #94bbff;\n    --link-hover: #f1f1f1;\n    --divider: #333;\n    --nav-bg: #1e1e1e;\n    --nav-text: #f1f1f1;\n    --nav-divider: #333;\n\n    /* Table-related dark theme */\n    --table-border-color: #333;\n    --table-box-shadow-color: rgba(255, 255, 255, 0.05);\n    --table-thead-background-color: #2a2a2a;\n    --table-tbody-background-color: #1e1e1e;\n    --table-split-line-color: #444;\n    --table-th-text-color: #f1f1f1;\n    --table-tbody-background-color-hover: #2c2c2c;\n\n    /* Form-related dark theme */\n    --form-border-color: #444;\n    --form-input-border-color: #555;\n    --form-input-background-color: #2c2c2c;\n    --form-input-text-color: #f1f1f1;\n    --form-button-text-color: #1e1e1e;\n    --form-button-background-color: #94bbff;\n    --form-button-background-color-hover: #b4d0ff;\n  }\n}\n\n/* Main Styles CSS */\n\n:root {\n  --border-size: 1px;\n  --nav-border-size: 4px;\n}\n\ndiv#root {\n  display: grid;\n  align-content: space-between;\n  grid-template-rows: auto 1fr auto;\n}\n\n.header {\n  display: grid;\n  padding: 0 1rem;\n  background-color: var(--nav-bg);\n  color: var(--nav-text);\n  border-bottom: var(--border-size) solid var(--nav-divider);\n}\n\n.nav {\n  display: grid;\n  grid-auto-flow: column;\n  height: 100%;\n}\n\n.nav__link--selected {\n  border-bottom: var(--nav-border-size) solid var(--nav-divider);\n}\n\n.nav__link {\n  -webkit-tap-highlight-color: transparent;\n  transition: color 0.5s;\n  color: var(--nav-text);\n  text-decoration: none;\n  padding: 1rem 0;\n}\n\n.nav__link:hover {\n  color: var(--link-text);\n}\n\n.footer {\n  display: grid;\n  grid-auto-flow: column;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--nav-bg);\n  padding: 1rem 0.5rem;\n  color: var(--text);\n  border-top: var(--border-size) solid var(--nav-divider);\n}\n\n.main {\n  overflow: scroll;\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n}\n\n.main::-webkit-scrollbar {\n  display: none;\n}\n\n.section {\n  display: grid;\n  grid-auto-flow: row;\n  justify-content: center;\n  gap: 1rem;\n  padding: 1rem;\n}\n\n.section__title,\n.section__subtitle,\n.section__description {\n  max-width: 42rem;\n}\n\n.section__title {\n  font-size: 2.5rem;\n  @media screen and (max-width: 600px) {\n    font-size: 2rem;\n  }\n}\n\n.section__subtitle {\n  margin-top: 1.5rem;\n  font-size: 1.5rem;\n  @media screen and (max-width: 600px) {\n    font-size: 1.25rem;\n  }\n}\n\n.section__description {\n  font-weight: 300;\n  line-height: 1.25rem;\n}\n\n.section__description--justify {\n  text-align: justify;\n  text-indent: 2rem;\n}\n\n.section__description--right {\n  text-align: right;\n}\n\n.section__link {\n  -webkit-tap-highlight-color: transparent;\n  transition: color 0.5s;\n  color: var(--link-text);\n  text-decoration: none;\n}\n\n.section__link:hover {\n  color: var(--link-text-hover);\n  text-decoration: underline;\n}\n\n.section__link:checked {\n  text-decoration: line-through;\n}\n\n.page__list {\n  display: grid;\n  grid-auto-flow: row;\n  gap: 1rem;\n  padding: 0 1rem 0 2rem;\n}\n\n.page__list__item {\n  text-align: left;\n}\n\n.page__list__item--decimal-style {\n  list-style: decimal;\n}\n\n.item__description {\n  text-align: start;\n}\n\n.lang-switcher {\n  appearance: none;\n  background-color: var(--nav-bg);\n  color: var(--nav-text);\n  border: 1px solid var(--nav-divider);\n  border-radius: 4px;\n  padding: 0.25rem 0.5rem;\n  font: inherit;\n  cursor: pointer;\n  align-self: center;\n  margin-left: auto;\n  transition:\n    border-color 0.2s,\n    color 0.2s;\n}\n\n.lang-switcher:hover {\n  border-color: var(--link-text);\n  color: var(--link-text);\n}\n\n.lang-switcher:focus-visible {\n  outline: 2px solid var(--link-text);\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
